// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3wNcv","label":"SetPasswdForm_label__3IuRU"};